<template>
    <l-layout :layout="['xs12']">
      <v-card>
        <v-card-text>
          <v-container class="pb-0" fluid grid-list-md>
            <v-form>
              <v-layout wrap>
                <v-flex :class="opt.layout" :key="i" v-for="(opt, i) in formDefine">
                  <l-input :config="opt" v-model="infoForm[opt.key]" :disabled="status==='readonly'"></l-input>
                </v-flex>
              </v-layout>
            </v-form>
            <v-layout justify-center>
              <v-btn class="primary" :disabled="status==='readonly'" :loading="loading" @click="setGroupInfo">提交</v-btn>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </l-layout>
</template>

<script>
import InfoCell from '../../components/infoCell'
import {ReservationGroup, ReservationAuthority, SpecificRule} from '../../object'
import rules from '../../utils/rules'
export default {
  name: 'NewPassGroup',
  data () {
    return {
      infoForm: {},
      opts: [
        {
          key: 'name',
          label: '分组名称',
          layout: ['xs12'],
          icon: '$vuetify.icons.group',
        },
        {
          key: 'description',
          label: '分组描述',
          layout: ['xs12'],
          textarea: true,
          icon: '$vuetify.icons.description',
        },
        {
          key: 'priority',
          label: '优先级别',
          layout: ['xs12', 'sm6'],
          icon: '$vuetify.icons.level',
        },
        {
          key: 'expirationTime',
          label: '过期时间',
          layout: ['xs12', 'sm6'],
          icon: '$vuetify.icons.datetime',
        },
        {
          key: 'osdMsgIn',
          label: '进场屏显提示',
          layout: ['xs12'],
          textarea: true,
          icon: '$vuetify.icons.led',
        },
        {
          key: 'vcbMsgIn',
          label: '进场语音提示',
          layout: ['xs12'],
          textarea: true,
          icon: '$vuetify.icons.audio',
        },
        {
          key: 'osdMsgOut',
          label: '出场屏显提示',
          layout: ['xs12'],
          textarea: true,
          icon: '$vuetify.icons.led',
        },
        {
          key: 'vcbMsgOut',
          label: '出场语音提示',
          layout: ['xs12'],
          textarea: true,
          icon: '$vuetify.icons.audio',
        },
      ],
      formDefine: [
        {
          type: 'input',
          key: 'name',
          label: '分组名称',
          layout: ['xs12'],
          rules: [rules.requiredS()],
          prependIcon: '$vuetify.icons.group',
        },
        {
          type: 'input',
          key: 'description',
          label: '分组描述',
          layout: ['xs12'],
          rules: [rules.requiredS()],
          prependIcon: '$vuetify.icons.description',
        },
        {
          type: 'input',
          key: 'priority',
          label: '优先级别',
          layout: ['xs12', 'sm6'],
          prependIcon: '$vuetify.icons.level',
        },
        {
          type: 'datetime',
          key: 'expirationTime',
          label: '过期时间',
          rules: [rules.requiredS()],
          layout: ['xs12', 'sm6'],
        },
        {
          rows: 1,
          autoGrow: true,
          type: 'textarea',
          key: 'ledPromptIn',
          label: '进场屏显提示',
          layout: ['xs12'],
          rules: [rules.requiredS()],
          prependIcon: '$vuetify.icons.led',
        },
        {
          rows: 1,
          autoGrow: true,
          type: 'textarea',
          key: 'audioPromptIn',
          label: '进场语音提示',
          layout: ['xs12'],
          rules: [rules.requiredS()],
          prependIcon: '$vuetify.icons.audio',
        },
        {
          rows: 1,
          autoGrow: true,
          type: 'textarea',
          key: 'ledPromptOut',
          label: '出场屏显提示',
          layout: ['xs12'],
          rules: [rules.requiredS()],
          prependIcon: '$vuetify.icons.led',
        },
        {
          rows: 1,
          autoGrow: true,
          type: 'textarea',
          key: 'audioPromptOut',
          label: '出场语音提示',
          layout: ['xs12'],
          rules: [rules.requiredS()],
          prependIcon: '$vuetify.icons.audio',
        },
      ],
      status: 'new',
      loading: false
    }
  },
  created () {
    this.infoForm = new ReservationGroup()
  },
  methods: {
    async  setGroupInfo () {
      try {
        this.loading = true
        let g = await this.$store.dispatch('passControl/setPassGroup', this.infoForm)
        this.status = 'readonly'
        /*      let keys = [
                  'name',
                  'description',
                  'priority',
                  'expirationTime',
                  'ledPromptIn',
                  'audioPromptIn',
                  'ledPromptOut',
                  'audioPromptOut',
                ]
                for (let key of keys) {
                  this.$set(this.data.obgrp, key, g[key])
                } */
        /* this.goReadonly() */
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
      finally {
        this.loading = false
      }
    },
  }
}
</script>

<style scoped>

</style>
